import * as React from 'react';

interface Props {
  children: React.ReactNode;
  /** Additional classes to apply */
  className?: string;
}

export const Cell: React.FC<Props> = (props: Props) => {
  const { children, className } = props;
  return <div className={`w-full h-full p-2 ${className}`}>{children}</div>;
};
